export default {
    indicator: {
        backgroundColor: "#008CB4",
    }
}